import { render } from "./BaseArrow.vue?vue&type=template&id=9757a520&scoped=true"
import script from "./BaseArrow.vue?vue&type=script&lang=js"
export * from "./BaseArrow.vue?vue&type=script&lang=js"

import "./BaseArrow.vue?vue&type=style&index=0&id=9757a520&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.22_vue@3.5.22_typescript@5.6.2__webpack@5.102.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9757a520"]])

export default __exports__